import { createActions } from 'redux-actions';
import types from 'state/direct-order-recurring/ui/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_FETCHING]: (isFetching) => ({ isFetching }),
  [types.SET_SUBMITTING]: (isSubmitting) => ({ isSubmitting }),
});

export default directOrderRecurring;
